<template>
  <div class="table-wrapper" v-show="isOpen">
    <div class="layer" id="success-bidding-confirm-modal">
      <div class="a-modal">
        <button class="btn-close" @click="toggleShowModal">
          <img src="@/assets/images/x.svg" alt="close modal"/>
        </button>
        <div class="a-modal__header">
          <span class="text-lg w6">取引ステータス</span>
        </div>
        <div class="a-modal__body">
          <div class="bid-table">
            <table>
              <thead>
              <tr>
                <th></th>
                <th class="th_no">No</th>
                <th class="th_name">物件名</th>
                <th class="th_status">ステータス</th>
                <th class="th_action">アクション</th>
              </tr>
              </thead>
            </table>
            <div class="scroll-table">
              <table>
                <tbody>
                <tr
                  :class="[
                  i === 0 ? 'tr_first' : '',
                   isHideEventBidder ? 'd-none' : ''
                ]"
                  v-for="(item, i) of getEventWonBid.bidder_events"
                  :key="i"
                >
                  <td
                    class="td_title"
                    v-if="i === 0"
                    :rowspan="getEventWonBid.bidder_events.length"
                  >
                    落札者メニュー
                  </td>
                  <td class="td_no">{{ i + 1 }}</td>
                  <td class="td_name">
                    <router-link
                      v-if="item.status !== 10 && item.estate_status !== 0"
                      :to="`/estate-info/estate-detail/${item.estate_id}`"
                    >
                      {{ ellipsisText(item.estate_name) }}
                    </router-link>
                    <span v-else>
                    {{ ellipsisText(item.estate_name) }}
                  </span>
                  </td>
                  <td class="td_status">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getBidderStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-action-bidder">
                    <button
                      v-if="item.status === 1"
                      class="btn-consent"
                      @click="moveTo91Case1(item.won_bid_id)"
                    >承諾
                    </button>
                    <button
                      v-if="item.status === 2"
                      class="btn-consent"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >承諾
                    </button>
                    <button
                      v-if="item.status === 3"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                  </td>
                </tr>
                <tr
                  :class="[
                  i === 0 ? 'tr_first' : '',
                   isHideEventSeller ? 'd-none' : ''
                ]"
                  v-for="(item, i) of getEventWonBid.seller_events"
                  :key="i"
                >
                  <td
                    class="td_title"
                    v-if="i === 0"
                    :rowspan="getEventWonBid.seller_events.length"
                  >
                    出品者メニュー
                  </td>
                  <td class="td_no">{{ i + 1 }}</td>
                  <td class="td_name">
                    <router-link
                      v-if="item.status !== 10 && item.estate_status !== 0"
                      :to="`/estate-detail-seller/${item.estate_id}`"
                    >
                      {{ ellipsisText(item.estate_name) }}
                    </router-link>
                    <span v-else>
                    {{ ellipsisText(item.estate_name) }}
                  </span>
                  </td>
                  <td class="td_status">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getSellerStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-bid_management">
                    <div class="td_action-text" v-if="item.status === 1 || item.status === 5">
                      <CountDown
                        :time-start="item.won_bid_start_time"
                        @end-count-down="getEventBidding"
                      />
                    </div>
                    <button
                      v-else-if="item.status === 2"
                      class="btn-message"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >繰り上げ
                    </button>
                    <button
                      v-else-if="item.status === 3"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                    <button
                      v-else-if="item.status === 6"
                      class="btn-message"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >繰り上げ
                    </button>
                    <button
                      v-else-if="item.status === 7"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                    <button
                      v-else-if="[4,8,9,11].indexOf(item.status) !== -1"
                      class="btn-message"
                      @click="moveTo123(item.estate_id)"
                    >再出品
                    </button>
                  </td>
                </tr>
                <tr
                  :class="[
                  i === 0 ? 'tr_first' : '',
                   isHideEventForwarder ? 'd-none' : ''
                ]"
                  v-for="(item, i) of getEventWonBid.forwarder_events"
                  :key="i"
                >
                  <td
                    class="td_title"
                    v-if="i === 0"
                    :rowspan="getEventWonBid.forwarder_events.length"
                  >
                    繰り上げ落札<br>者メニュー
                  </td>
                  <td class="td_no">{{ i + 1 }}</td>
                  <td class="td_name">
                    <router-link
                      v-if="item.status !== 10 && item.estate_status !== 0"
                      :to="`/estate-info/estate-detail/${item.estate_id}`"
                    >
                      {{ ellipsisText(item.estate_name) }}
                    </router-link>
                    <span v-else>
                    {{ ellipsisText(item.estate_name) }}
                  </span>
                  </td>
                  <td class="td_status">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getForwarderStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-wait_consent">
                    <div v-if="[5,6].indexOf(item.status) !== -1">
                      <button @click="moveTo91Case4(item.won_bid_id)">承諾</button>
                      <button @click="moveTo91Case4(item.won_bid_id)">辞退</button>
                    </div>
                    <button
                      v-else-if="item.status === 7"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="table-mb">
            <div class="bid-table-mb">
              <div
                class="table-header"
                :class="{ 'd-none': isHideEventBidder }"
              >落札者メニュー
              </div>
              <table
                :class="{ 'd-none': isHideEventBidder }"
              >
                <thead>
                <tr>
                  <th class="th_no">No</th>
                  <th class="th_name">物件名</th>
                  <th class="th_status">ステータス</th>
                  <th class="th_action">アクション</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  :class="i === 0 ? 'tr_first' : ''"
                  v-for="(item, i) of getEventWonBid.bidder_events"
                  :key="i"
                >
                  <td class="td_no">{{ i + 1 }}</td>
                  <td class="td_name">
                    <router-link
                      v-if="item.status !== 10 && item.estate_status !== 0"
                      :to="`/estate-info/estate-detail/${item.estate_id}`"
                    >
                      {{ ellipsisText(item.estate_name, false) }}
                    </router-link>
                    <span v-else>
                      {{ ellipsisText(item.estate_name, false) }}
                    </span>
                  </td>
                  <td class="td_status">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getBidderStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-action-bidder">
                    <button
                      v-if="item.status === 1"
                      class="btn-consent"
                      @click="moveTo91Case1(item.won_bid_id)"
                    >承諾
                    </button>
                    <button
                      v-if="item.status === 2"
                      class="btn-consent"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >承諾
                    </button>
                    <button
                      v-if="item.status === 3"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

              <div
                class="table-header"
                :class="{ 'd-none': isHideEventSeller }"
              >出品者メニュー
              </div>
              <table
                :class="{ 'd-none': isHideEventSeller }"
              >
                <thead>
                <tr>
                  <th class="th_no">No</th>
                  <th class="th_name">物件名</th>
                  <th class="th_status">ステータス</th>
                  <th class="th_action">アクション</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  :class="i === 0 ? 'tr_first' : ''"
                  v-for="(item, i) of getEventWonBid.seller_events"
                  :key="i"
                >
                  <td class="td_no">{{ i + 1 }}</td>
                  <td class="td_name">
                    <router-link
                      v-if="item.status !== 10 && item.estate_status !== 0"
                      :to="`/estate-detail-seller/${item.estate_id}`"
                    >
                      {{ ellipsisText(item.estate_name, false) }}
                    </router-link>
                    <span v-else>
                      {{ ellipsisText(item.estate_name, false) }}
                    </span>
                  </td>
                  <td class="td_status">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getSellerStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-bid_management">
                    <div class="td_action-text" v-if="item.status === 1 || item.status === 5">
                      <CountDown
                        :time-start="item.won_bid_start_time"
                        @end-count-down="getEventBidding"
                      />
                    </div>
                    <button
                      v-else-if="item.status === 2"
                      class="btn-message"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >繰り上げ
                    </button>
                    <button
                      v-else-if="item.status === 3"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                    <button
                      v-else-if="item.status === 6"
                      class="btn-message"
                      @click="moveTo91Case3(item.won_bid_id)"
                    >繰り上げ
                    </button>
                    <button
                      v-else-if="item.status === 7"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                    <button
                      v-else-if="[4,8,9,11].indexOf(item.status) !== -1"
                      class="btn-message"
                      @click="moveTo123(item.estate_id)"
                    >再出品
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>

              <div
                class="table-header"
                :class="{ 'd-none': isHideEventForwarder }"
              >繰り上げ落札者メニュー
              </div>
              <table
                :class="{ 'd-none': isHideEventForwarder }"
              >
                <thead>
                <tr>
                  <th class="th_no">No</th>
                  <th class="th_name">物件名</th>
                  <th class="th_status">ステータス</th>
                  <th class="th_action">アクション</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  :class="i === 0 ? 'tr_first' : ''"
                  v-for="(item, i) of getEventWonBid.forwarder_events"
                  :key="i"
                >
                  <td class="td_no cus_last_td">{{ i + 1 }}</td>
                  <td class="td_name cus_last_td">
                    <a>{{ ellipsisText(item.estate_name, false) }}</a>
                  </td>
                  <td class="td_status cus_last_td">
                    <CusStatusDot :item="item.status">
                      <span class="shape"></span>
                      <span class="max-line-height"
                            v-html="getForwarderStatusText(item.status)"></span>
                    </CusStatusDot>
                  </td>
                  <td class="td_action td-wait_consent">
                    <div v-if="[5,6].indexOf(item.status) !== -1">
                      <button @click="moveTo91Case4(item.won_bid_id)">承諾</button>
                      <button @click="moveTo91Case4(item.won_bid_id)">辞退</button>
                    </div>
                    <button
                      v-else-if="item.status === 7"
                      class="btn-consent"
                      @click="moveTo91Case5(item.won_bid_id)"
                    >メッセージ
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="a-modal__footer">
          <button @click="toggleShowModal" class="btn">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CusStatusDot from '@/components/message/CustomStatusDot.vue';
import CountDown from '@/components/message/CountDown.vue';
import { mapGetters } from 'vuex';
import { BIDDING_STATUS, FORWARDER_STATUS, SELLER_STATUS } from '@/constants/eventBidding';

export default {
  components: {
    CusStatusDot,
    CountDown,
  },
  data() {
    return {
      isOpen: false,
      BIDDING_STATUS,
      SELLER_STATUS,
      FORWARDER_STATUS,
      isHideEventBidder: true,
      isHideEventSeller: true,
      isHideEventForwarder: true,
    };
  },
  computed: {
    ...mapGetters('event-won-bid', ['getEventWonBid']),
  },
  created() {
    this.getEventBidding()
      .then(() => {
        this.updateFirstView();
      });
  },
  watch: {
    getEventWonBid: {
      handler() {
        if (this.getEventWonBid) {
          this.isHideEventBidder = this.getEventWonBid.bidder_events?.length <= 0;
          this.isHideEventSeller = this.getEventWonBid.seller_events?.length <= 0;
          this.isHideEventForwarder = this.getEventWonBid.forwarder_events?.length <= 0;
          this.isOpen = !(this.isHideEventBidder
            && this.isHideEventSeller
            && this.isHideEventForwarder);
        }
      },
      deep: true,
    },
  },
  methods: {
    toggleShowModal() {
      this.isOpen = !this.isOpen;
    },
    async getEventBidding() {
      this.$root.$refs.loading.start();
      await this.$store.dispatch('event-won-bid/actGetEventWonBid')
        .then(() => {
          this.$root.$refs.loading.finish();
        });
    },
    getBidderStatusText(status) {
      const statusFind = this.BIDDING_STATUS.filter(item => item.key === status);
      if (statusFind.length) return statusFind[0].value;
      return '';
    },
    getSellerStatusText(status) {
      const statusFind = this.SELLER_STATUS.filter(item => item.key === status);
      if (statusFind.length) return statusFind[0].value;
      return '';
    },
    getForwarderStatusText(status) {
      const statusFind = this.FORWARDER_STATUS.filter(item => item.key === status);
      if (statusFind.length) return statusFind[0].value;
      return '';
    },
    async updateFirstView() {
      const listFirstView = [];
      const listFirstViewBidding = [];
      if (this.getEventWonBid) {
        if (this.getEventWonBid.bidder_events.length) {
          this.getEventWonBid.bidder_events.forEach(item => {
            if (
              (item.status === 4 || item.status === 10 || item.estate_status === 0)
              && item.first_view
              && listFirstView.indexOf(item.won_bid_id) === -1) {
              listFirstView.push(item.won_bid_id);
            }
          });
        }
        if (this.getEventWonBid.seller_events.length) {
          this.getEventWonBid.seller_events.forEach(item => {
            if (!item.first_view && listFirstViewBidding.indexOf(item.u_estate_bidding_id) === -1) {
              listFirstViewBidding.push(item.u_estate_bidding_id);
            }
            if (
              (item.status === 4
                || item.status === 8
                || item.status === 9
                || item.status === 11
                || item.estate_status === 0)
              && item.first_view
              && listFirstViewBidding.indexOf(item.estate_bidding_id) === -1) {
              listFirstViewBidding.push(item.estate_bidding_id);
            }
          });
        }
        if (this.getEventWonBid.forwarder_events.length) {
          this.getEventWonBid.forwarder_events.forEach(item => {
            if ((item.status === 8
                || item.status === 9
                || item.status === 10
                || item.estate_status === 0)
              && item.first_view
              && listFirstView.indexOf(item.won_bid_id) === -1) {
              listFirstView.push(item.won_bid_id);
            }
          });
        }
        if (listFirstView.length) {
          const body = {
            won_bidders: listFirstView,
          };
          await this.$store.dispatch('event-won-bid/actUpdateFirstView', body);
        }
        if (listFirstViewBidding.length) {
          const body = {
            bidding_won_bidders: listFirstViewBidding,
          };
          await this.$store.dispatch('event-won-bid/actUpdateFirstViewBidding', body);
        }
      }
    },
    moveTo91Case1(wonBidId) {
      this.toggleShowModal();
      this.$router.push({
        name: 'Message Detail',
        params: { won_bid_id: wonBidId },
      });
    },
    moveTo91Case3(wonBidId) {
      this.toggleShowModal();
      this.$router.push({
        name: 'Message Detail',
        params: { won_bid_id: wonBidId },
      });
    },
    moveTo91Case4(wonBidId) {
      this.toggleShowModal();
      this.$router.push({
        name: 'Message Detail',
        params: { won_bid_id: wonBidId },
      });
    },
    moveTo91Case5(wonBidId) {
      this.toggleShowModal();
      this.$router.push({
        name: 'Message Detail',
        params: { won_bid_id: wonBidId },
      });
    },
    moveTo123(estateId) {
      // this.toggleShowModal();
      this.$router.push({
        name: 'EstateExhibitSeller',
        params: { id: estateId },
      });
    },
    ellipsisText(text, isPC = true) {
      // if (isPC) {
      //   if (text && text.length > 35) {
      //     const stringSplit = text.substr(0, 35);
      //     return stringSplit.concat('...');
      //   }
      //   return text;
      // }
      // if (text && text.length > 5) {
      //   const stringSplit = text.substr(0, 5);
      //   return stringSplit.concat('...');
      // }
      return text;
    },
  },
};
</script>
